// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cta-bottom[data-v-93381a2e]{background-color:var(--lightgrey-price-box);padding:2.5rem}@media(min-width:768px){.cta-bottom h3[data-v-93381a2e]{font-size:32px}}@media(min-width:768px){.cta-bottom p[data-v-93381a2e]{font-size:20px}}.cta-bottom .button[data-v-93381a2e]{border:none;text-transform:capitalize;font-family:var(--font-bold)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
